import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import {
    Header,
    BasicOptionContainer,
    ContentBody,
    Add,
    InputCont,
    CheckBoxContainer,
    HeaderContainer,
    DetailBody,
    AddRecipientContainer,
    FooterContent,
    ButtonContainer,
    StyledHorizontalRow,
    Row,
    Icon,
    Status,
    RegularSmallText,
    InputWithRecipientContainer,
    ErrorContainer,
} from 'src/pages/orders/components/reportsAndInvoice/sendUsageReport/SendUsageReport.styled';
import {
    BackButtonIcon,
    BackButtonContainer,
    BackText,
} from 'src/pages/orders/components/searchOrdersPanel/searchOrdersResult/SearchOrdersResult.styled.jsx';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import { sendInvoice } from 'src/pages/orders/redux/actions';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import Input from 'src/common/components/form/input/Input';
import Close from 'src/assets/images/ModalClose.svg';
import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import MDICheckCircle from 'src/assets/images/MDICheckCircle.svg';
import {
    CloseIconContainer,
    CloseIcon,
} from 'src/pages/orders/components/orderDetails/orderDetailHeader/OrderDetailHeader.styled';
import {
    getFormattedPhoneNumber,
    getHyphenFormattedNumber,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { XX_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { validateEmail as validateEmailCommon } from 'src/pages/reportUsage/utils/reportUsageUtil';

const RequestInvoice = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const userDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );

    const myCaseRef = useSelector(
        (state) => state.orderSummaryReducer.myCaseRef
    );

    const { statusCode, loading } = useSelector(
        (state) => state.sendInvoiceReducer
    );

    const [userEmailIdSelected, setUserEmailIdSelected] = useState(false);

    const [, setSendTypeChecked] = useState({
        isEmail: true,
        isFax: false,
    });
    const [selectedRadio, setSelectedRadio] = useState('isEmail');
    const [emailInputBoxes, setEmailInputBoxes] = useState([
        { value: '', errorMessage: '' },
    ]);
    const [faxInputBoxes, setFaxInputBoxes] = useState([
        { value: '', errorMessage: '' },
    ]);

    const [expandedCard, setExpandedCard] = useState(true);

    const toggleCard = () => {
        setExpandedCard(!expandedCard);
    };

    const onAddEmailRecipientHandler = () => {
        let previous = [...emailInputBoxes, { value: '', errorMessage: '' }];
        setEmailInputBoxes(previous);
    };

    const onChangeEmail = (index, value) => {
        const emailInputBox = [...emailInputBoxes];
        if (value === '') {
            emailInputBox[index].errorMessage = '';
        }
        emailInputBox[index].value = value;
        setEmailInputBoxes(emailInputBox);
    };

    const onAddFaxRecipientHandler = () => {
        let previous = [...faxInputBoxes, { value: '', errorMessage: '' }];
        setFaxInputBoxes(previous);
    };

    const onChangeFax = (index, value) => {
        const faxInputBox = [...faxInputBoxes];
        const prevValue = faxInputBox[index].value;
        faxInputBox[index].value =
            value === '' ? '' : faxNumberValidate(value, prevValue);
        setFaxInputBoxes(faxInputBox);
    };

    const faxNumberValidate = (faxValue, prevValue) => {
        let isnum = null;
        let value = faxValue;
        const re = /^[0-9\b]+$/;

        const numbersOnlyString = value.replace(/\D/g, '');
        isnum =
            numbersOnlyString.length > 0
                ? /^\d+$/.test(numbersOnlyString)
                : null;
        if (re.test(numbersOnlyString)) {
            if (isnum && numbersOnlyString.length < 11) {
                return numbersOnlyString.substring(0, 10);
            } else if (isnum) {
                return prevValue;
            }
        } else {
            return prevValue;
        }
    };

    const onSendTypeChangeHandler = (name) => {
        name === 'isEmail'
            ? setFaxInputBoxes([{ value: '', errorMessage: '' }])
            : setEmailInputBoxes([{ value: '', errorMessage: '' }]);
        setSelectedRadio(name);
    };

    const validateEmail = (email) => {
        const result = validateEmailCommon(email);        
        return result;
    };

    const validateFax = (number) => {
        return number && number?.length >= 10 ? true : false;
    };

    const validateHandler = (validateList, isEmail) => {
        const lists = [...validateList];

        const checkNonEmptyLists =
            lists.length > 1
                ? lists.filter((x) => x.value !== '')?.length > 0
                    ? true
                    : false
                : false;

        const validatedList =
            lists.length > 1 && checkNonEmptyLists
                ? lists?.map((data) => {
                      if (data && data.value) {
                          isEmail
                              ? !validateEmail(data.value)
                                  ? (data.errorMessage = t(
                                        'orders.reportsAndInvoice.viewReport.reqinvoice'
                                    ))
                                  : (data.errorMessage = '')
                              : !validateFax(data.value)
                              ? (data.errorMessage = t(
                                    'orders.reportsAndInvoice.viewReport.invalidfax'
                                ))
                              : (data.errorMessage = '');
                      } else {
                          data.errorMessage = '';
                      }
                      return { ...data };
                  })
                : lists?.map((data, index) => {
                      if (
                          index === 0 &&
                          !(userEmailIdSelected && data.value === '')
                      ) {
                          isEmail
                              ? !validateEmail(data.value)
                                  ? (data.errorMessage = t(
                                        'orders.reportsAndInvoice.viewReport.reqinvoice'
                                    ))
                                  : (data.errorMessage = '')
                              : !validateFax(data.value)
                              ? (data.errorMessage = t(
                                    'orders.reportsAndInvoice.viewReport.invalidfax'
                                ))
                              : (data.errorMessage = '');
                      }
                      return { ...data };
                  });
        const checkNotValid =
            validateList.filter((x) => x.errorMessage !== '').length > 0;
        return { validatedList: validatedList, checkValid: checkNotValid };
    };

    const getEmailIdsTobeSent = (emailInputBoxes, userEmailId) => {
        const emailsFromEmailInputBoxes = emailInputBoxes
            ?.filter((x) => x.value !== '')
            .map((email) => email.value)
            .join(',');
        if (emailsFromEmailInputBoxes.length > 1) {
            return `${emailsFromEmailInputBoxes},${userEmailId}`;
        } else {
            return userEmailId;
        }
    };

    const onSendInvoiceHandler = () => {
        let emailInputs = [];
        let faxInputs = [];

        if (selectedRadio === 'isEmail') {
            const newEmailList = validateHandler(emailInputBoxes, true);
            setEmailInputBoxes(newEmailList.validatedList);
            emailInputs = [...newEmailList.validatedList];
            if (newEmailList.checkValid) {
                return;
            }
        }

        if (selectedRadio === 'isFax') {
            const newFaxList = validateHandler(faxInputBoxes, false);
            setFaxInputBoxes(newFaxList.validatedList);
            faxInputs = [...newFaxList.validatedList];
            if (newFaxList.checkValid) {
                return;
            }
        }

        dispatch(
            sendInvoice({
                copyMe: userEmailIdSelected,
                emailIds:
                    selectedRadio === 'isEmail'
                        ? userEmailIdSelected
                            ? getEmailIdsTobeSent(
                                  emailInputBoxes,
                                  userDetails.emailId
                              )
                            : emailInputs
                                  ?.filter((x) => x.value !== '')
                                  .map((email) => email.value)
                                  .join(',')
                        : '',
                faxNumbers:
                    selectedRadio === 'isFax'
                        ? faxInputs
                              ?.filter((x) => x.value !== '')
                              .map((fax) => getHyphenFormattedNumber(fax.value))
                              .join(',')
                        : '',
                myCaseRef: props.myCaseRef ? props.myCaseRef : myCaseRef,
            })
        );
    };

    const {
        requestInvoiceState,
        isRequestInvoiceSearchListPage,
        isRequestInvoiceOrderListPage,
    } = useSelector((state) => state.orderSummaryReducer);

    useEffectWithErrorLogging(() => {
        if (statusCode === '10736') {
            resetStateHandler();
        }
    }, [statusCode]);

    const resetStateHandler = () => {
        setSendTypeChecked({
            isEmail: true,
            isFax: false,
        });
        setEmailInputBoxes([{ value: '', errorMessage: '' }]);
        setFaxInputBoxes([{ value: '', errorMessage: '' }]);
        setSelectedRadio('isEmail');
        setUserEmailIdSelected(false);
    };

    useEffectWithErrorLogging(() => {
        resetStateHandler();
    }, [requestInvoiceState]);

    return (
        <>
            {(requestInvoiceState || props.myCaseRef) && (
                <ModalDialog
                id="orders-requestinvoice-modal-dialog"
                    modalHeight={'calc(100vh - 110px)'}
                    modalWidth={'70%'}
                    left={'0%'}
                    right={'0%'}
                    top={'7%'}
                    bottom={'5%'}
                    padding={'0px'}
                    height={'100%'}
                    marginTop={'7rem'}
                    zIndex={'2000'}
                    onClick={props.onCloseRequestInvoiceHandler}
                    handleClose={() => props.onCloseRequestInvoiceHandler()}
                >
                    <ContentBody>
                        <HeaderContainer>
                            <Header fontSize="18px">
                                {t(
                                    'orders.reportsAndInvoice.requestInvoice.requestInvoiceButton'
                                )}
                            </Header>

                            {/* <CloseIconContainer>
                                <CloseIcon
                                    mobilePath={Close}
                                    show={true}
                                    onClick={props.onCloseRequestInvoiceHandler}
                                />
                            </CloseIconContainer> */}
                        </HeaderContainer>
                        {!isRequestInvoiceSearchListPage &&
                        !isRequestInvoiceOrderListPage ? (
                            <BackButtonContainer
                            id="orders-requestinvoice-back-button-container"
                                onClick={props.onCloseRequestInvoiceHandler}
                            >
                                <BackButtonIcon src={BackIcon} />
                                <BackText>
                                    {t('common.backToText')}{' '}
                                    {props.myCaseRef
                                        ? props.myCaseRef
                                        : myCaseRef}
                                </BackText>
                            </BackButtonContainer>
                        ) : null}

                        <DetailBody
                            scrollBarWidth={'8px'}
                            scrollBarBackgroundColor={'#888'}
                            scrollBarBorderRadius={'10px'}
                            mediumDeviceScrollBarDisplay={'block'}
                        >
                            <CollapsableCard
                                id="orders-requestInvoice-requestInvoice-recipients"
                                title="Recipients"
                                onClick={toggleCard}
                                isExpanded={expandedCard}
                                padding="10px 20px"
                            >
                                {expandedCard && (
                                    <>
                                        <Header letterSpacing="-0.12px">
                                            {t(
                                                'orders.reportsAndInvoice.requestInvoice.sendTo'
                                            )}
                                        </Header>
                                        <BasicOptionContainer mbWidth={'60%'}>
                                            <RadioButton
                                                noWrap = {'nowrap'}
                                                label={t(
                                                    'orders.reportsAndInvoice.requestInvoice.email'
                                                )}
                                                id={'email'}
                                                isChecked={
                                                    selectedRadio === 'isEmail'
                                                }
                                                handleChange={() =>
                                                    onSendTypeChangeHandler(
                                                        'isEmail'
                                                    )
                                                }
                                            />
                                            <RadioButton
                                                noWrap = {'nowrap'}
                                                label={t(
                                                    'orders.reportsAndInvoice.requestInvoice.Fax'
                                                )}
                                                id={'fax'}
                                                isChecked={
                                                    selectedRadio !== 'isEmail'
                                                }
                                                handleChange={() =>
                                                    onSendTypeChangeHandler(
                                                        'isFax'
                                                    )
                                                }
                                            />
                                        </BasicOptionContainer>

                                        {selectedRadio === 'isEmail' &&
                                            emailInputBoxes.map(
                                                (item, index) => (
                                                    <React.Fragment key={index}>
                                                        <AddRecipientContainer
                                                            flexDirection={
                                                                'column'
                                                            }
                                                            alignItems="flex-start"
                                                        >
                                                            <InputWithRecipientContainer>
                                                                <InputCont>
                                                                    <Input
                                                                        id={`orders-requestinvoice-email-input-${index}`}
                                                                        key={index}
                                                                        placeholder={t(
                                                                            'orders.reportsAndInvoice.requestInvoice.enterEmailAddress'
                                                                        )}
                                                                        onChange={(
                                                                            event
                                                                        ) => {
                                                                            onChangeEmail(
                                                                                index,
                                                                                event
                                                                                    .target
                                                                                    .value
                                                                            );
                                                                            const emailInputBox =
                                                                                [
                                                                                    ...emailInputBoxes,
                                                                                ];
                                                                            emailInputBox.map(
                                                                                (
                                                                                    email
                                                                                ) => {
                                                                                    if (
                                                                                        email.value ===
                                                                                        ''
                                                                                    ) {
                                                                                        email.errorMessage =
                                                                                            '';
                                                                                    }
                                                                                    return email;
                                                                                }
                                                                            );
                                                                            setEmailInputBoxes(
                                                                                emailInputBox
                                                                            );
                                                                        }}
                                                                        value={
                                                                            item.value ||
                                                                            ''
                                                                        }
                                                                    />
                                                                </InputCont>

                                                                {emailInputBoxes.length -
                                                                    1 ===
                                                                    index && (
                                                                    <Add
                                                                    id="orders-requestinvoice-add-email-recipient-button"
                                                                        onClick={
                                                                            onAddEmailRecipientHandler
                                                                        }
                                                                    >
                                                                        {t(
                                                                            'orders.reportsAndInvoice.requestInvoice.addrecipit'
                                                                        )}
                                                                    </Add>
                                                                )}
                                                            </InputWithRecipientContainer>

                                                            {item?.errorMessage && (
                                                                <ErrorContainer>
                                                                    {
                                                                        item.errorMessage
                                                                    }
                                                                </ErrorContainer>
                                                            )}
                                                        </AddRecipientContainer>
                                                        {emailInputBoxes.length -
                                                            1 ===
                                                            index && (
                                                            <CheckBoxContainer>
                                                                <Checkbox
                                                                    checked={userEmailIdSelected}
                                                                    label={`${t(
                                                                        'orders.reportsAndInvoice.requestInvoice.SendCopy'
                                                                    )} ${
                                                                        userDetails.emailId
                                                                    }`}
                                                                    onCheckboxSelectionChange={() =>
                                                                        setUserEmailIdSelected(
                                                                            !userEmailIdSelected
                                                                        )
                                                                    }
                                                                    id="orders-reportsAndInvoice-requestInvoice-SendCopy-checkbox"
                                                                    margin={'0 16px 0 0'}
                                                                    labelStyleObj={{padding: XX_SMALL_TEXT_PX,}}
                                                                    background={'none'}
                                                                    checkboxBorder={'1.5px solid #555555'}
                                                                    alignItemDirection={'center'}
                                                                    hoverEffect={'false'}
                                                                    disableFocusEffect={'true'}
                                                                    checkboxWrapperDisplay={'inline-flex'}
                                                                />
                                                            </CheckBoxContainer>
                                                        )}
                                                    </React.Fragment>
                                                )
                                            )}
                                        {selectedRadio !== 'isEmail' &&
                                            faxInputBoxes.map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <AddRecipientContainer
                                                        flexDirection={'column'}
                                                        alignItems="flex-start"
                                                    >
                                                        <InputWithRecipientContainer>
                                                            <InputCont
                                                                key={index}
                                                            >
                                                                <Input
                                                                 id={`orders-requestinvoice-fax-input-${index}`}
                                                                    placeholder={t(
                                                                        'orders.reportsAndInvoice.requestInvoice.faxNumber'
                                                                    )}
                                                                    onChange={(
                                                                        event
                                                                    ) =>
                                                                        onChangeFax(
                                                                            index,
                                                                            event
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                    value={
                                                                        item?.value
                                                                            ? getFormattedPhoneNumber(
                                                                                  item.value,
                                                                                  true
                                                                              )
                                                                            : ''
                                                                    }
                                                                />
                                                            </InputCont>

                                                            {faxInputBoxes.length -
                                                                1 ===
                                                                index && (
                                                                <Add
                                                                 id="orders-requestinvoice-add-fax-recipient-button"
                                                                    onClick={
                                                                        onAddFaxRecipientHandler
                                                                    }
                                                                >
                                                                    {t(
                                                                        'orders.reportsAndInvoice.requestInvoice.addrecipit'
                                                                    )}
                                                                </Add>
                                                            )}
                                                        </InputWithRecipientContainer>

                                                        {item?.errorMessage && (
                                                            <ErrorContainer>
                                                                {
                                                                    item.errorMessage
                                                                }
                                                            </ErrorContainer>
                                                        )}
                                                    </AddRecipientContainer>
                                                </React.Fragment>
                                            ))}
                                        {statusCode === '10736' ? (
                                            <ButtonContainer
                                                justifyContent={'center'}
                                            >
                                                <Row padding={'5px 0px'}>
                                                    <Icon
                                                        id="request-invoice-icon"
                                                        src={MDICheckCircle}
                                                    ></Icon>
                                                    <Status>
                                                        <RegularSmallText
                                                            fontSize={'16px'}
                                                        >
                                                            {t(
                                                                'orders.reportsAndInvoice.requestInvoice.sentSuccessfully1'
                                                            )}
                                                        </RegularSmallText>
                                                    </Status>
                                                </Row>
                                            </ButtonContainer>
                                        ) : (
                                            <>
                                                <ButtonContainer
                                                    justifyContent={
                                                        'space-between'
                                                    }
                                                >
                                                    <Button
                                                    id={'orders-requestinvoice-cancel-button'}
                                                        show
                                                        //cancel
                                                        variant={ButtonStyles.cancel}
                                                        width="148px"
                                                        height="38px"
                                                        margin="0 5px 0 0"
                                                        clicked={
                                                            props.onCloseRequestInvoiceHandler
                                                        }
                                                        fontSize={'15px'}
                                                    >
                                                        {t(
                                                            'orders.reportsAndInvoice.requestInvoice.Cancel'
                                                        )}
                                                    </Button>
                                                    <Button
                                                      id={'orders-requestinvoice-sending-button'}
                                                        show
                                                        //primary
                                                        variant={ButtonStyles?.primary}
                                                        width="148px"
                                                        height="38px"
                                                        margin="0 0 0 5px"
                                                        clicked={
                                                            onSendInvoiceHandler
                                                        }
                                                        fontSize={'15px'}
                                                    >
                                                        {loading
                                                            ? 'Sending...'
                                                            : 'Send Invoice'}
                                                    </Button>
                                                </ButtonContainer>
                                            </>
                                        )}

                                        <StyledHorizontalRow />
                                    </>
                                )}
                            </CollapsableCard>
                        </DetailBody>
                    </ContentBody>
                    <FooterContent>
                        <BottomNavigation
                            justifyContent="flex-end"
                            moblieJustifyContent="center"
                            padding="11px 20px"
                        >
                            {statusCode === '10736' ? (
                                <Row padding={'5px 0px'}>
                                    <Icon 
                                    id="request-invoice-icon"
                                    src={MDICheckCircle}></Icon>
                                    <Status>
                                        <RegularSmallText fontSize={'16px'}>
                                            {t(
                                                'orders.reportsAndInvoice.requestInvoice.sentSuccessfully1'
                                            )}
                                        </RegularSmallText>
                                    </Status>
                                </Row>
                            ) : (
                                <>
                                    <Button
                                      id={'orders-requestinvoice-cancel2-button'}
                                        show
                                        //cancel
                                        variant={ButtonStyles.cancel}
                                        width="148px"
                                        height="38px"
                                        margin="0 5px"
                                        clicked={
                                            props.onCloseRequestInvoiceHandler
                                        }
                                        fontSize={'15px'}
                                    >
                                        {t(
                                            'orders.reportsAndInvoice.requestInvoice.Cancel'
                                        )}
                                    </Button>
                                    <Button
                                      id={'orders-requestinvoice-sending-button'}
                                        show
                                        //primary
                                        variant={ButtonStyles?.primary}
                                        width="148px"
                                        height="38px"
                                        margin="0 5px"
                                        clicked={onSendInvoiceHandler}
                                        fontSize={'15px'}
                                    >
                                        {loading
                                            ? 'Sending...'
                                            : 'Send Invoice'}
                                    </Button>
                                </>
                            )}
                        </BottomNavigation>
                    </FooterContent>
                </ModalDialog>
            )}
        </>
    );
};

export default RequestInvoice;
